"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (proposal) {
    return proposal && +proposal.ask_price;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/trade/askPriceFromProposal.js
// module id = 122
// module chunks = 0